import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
// import { multiTabsData } from "../../../global/utils/multiTabData";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { estudioGrupo } from "../../context/Actions/estudioGrupo/estudioGrupo";
import LaboratorioTxt from "./LaboratorioTxt";
import {
  LimpiarSelectGlobal,
  LimpiarSelectL,
  SelectUserGlobal,
  SelectUserL,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { showModal } from "../../context/Actions/modal/modal";
import { logoutLaboTurnos } from "../../context/Actions/turnos/laboTurnos";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Modal from "../../components/Genericos/Modal/Modal";
// import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import Toaster from "../../../global/component/Genericos/Toaster/Toaster";
import BuscadorLaboratorio from "../../components/Turnos/BuscadorLaboratorio/BuscadorLaboratorio";
// import MultitabHome from "../../components/Turnos/MultitabHome/MultitabHome";
// import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import Loading from "../../components/Genericos/Loading/Loading";
import "./Laboratorio.css";
import SegundoModal from "../../components/Genericos/SegundoModal/SegundoModal";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { GlobalContext } from "../../../global/context/Provider";
// import BuscadorTurnos from "../BuscadorTurnos/BuscadorTurnos";
import { motion } from "framer-motion";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import styled from "styled-components";
import { FaChevronLeft } from "react-icons/fa";

const Laboratorio = () => {
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    modalState,
    turnosDisponiblesDispatch,
    laboGrupoDispatch,
    laboGrupoState,
    selectDropDownDispatch,
    modalDispatch,
    segundoModalState,
    turnosDisponiblesState,
    laboTurnosDispatch,
    laboTurnosState,
  } = useContext(PortalContext);
  const history = useHistory();

  // Nuevo contexto
  const { authState, toasterState, configState } = useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  // const [tabsData, setTabsData] = useState(multiTabsData);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data === null) {
      estudioGrupo()(estudioGrupoDispatch);
    }
    if (laboGrupoState.laboGrupo.data === null) {
      laboGrupo()(laboGrupoDispatch);
    }
    if (laboGrupoState.laboGrupo.centros === null) {
      wsGetLaboCentros()(laboGrupoDispatch);
    }
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO"
    ) {
      logoutLaboTurnos()(laboTurnosDispatch);
      finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
    }

    //eslint-disable-next-line
  }, [configState.config.data]);

  // ONCHANGE DROPDOWN
  const onChangeMultitabMobile = (e) => {
    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth?.data?.paciente?.codigo &&
        e.manejoTurnos
      ) {
        SelectUserL({ id: e.id, paciente: e.paciente })(selectDropDownDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch
        );
      } else if (e.id !== authState.auth?.data?.paciente?.codigo) {
        // Toaster que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro"
        )(modalDispatch);

        LimpiarSelectL()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectL()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      }
    } else {
      LimpiarSelectL()(selectDropDownDispatch);
      // misma logica que en estudios
      // LimpiarSelectGlobal()(selectDropDownDispatch);
    }
  };

  // useEffect(() => {
  //   if (configState.config.data !== null) {
  //     let tabsAux = tabsData;
  //     if (configState.config.data.opcLaboratorio === false) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 2);
  //     }
  //     if (configState.config.data.opcRecetaDigital === false) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 3);
  //     }
  //     if (
  //       configState.config.data.opcRecetaDigital === false &&
  //       configState.config.data.opcLaboratorio === false &&
  //       configState.config.data.opcBuscadorTurnos === false
  //     ) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 3 && i.id !== 2);
  //     }
  //     if (configState.config.data.opcBuscadorTurnos) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 0 && i.id !== 1 && i.id !== 2);
  //     } else {
  //       tabsAux = tabsAux.filter((i) => i.id !== 5);
  //     }
  //     setTabsData(tabsAux);
  //   }
  // }, [configState.config.data]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <Loading
        dataLoading={
          laboTurnosState.laboTurnos.loading ||
          estudioGrupoState.estudioGrupo.loading ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading &&
            "Cargando laboratorio...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando laboratorio...") ||
          (laboTurnosState.laboTurnos.loading && "Cargando...")
        }
      />
      {/* <MultitabMobile
        posicionMultitab={
          multiTabState.multiTab.origen !== null &&
          multiTabState.multiTab.origen !== undefined
            ? multiTabState.multiTab.origen
            : 3
        }
        onChangeMultitabMobile={onChangeMultitabMobile}
        type={"LABO"}
      /> */}
      {estudioGrupoState.estudioGrupo.data && (
        <motion.div
          initial={{ opacity: 0, y: +100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
          className="ptur-bodyContainer-Laboratorio"
        >
          {/* <Sidebar /> */}
          <div className="ptur-laboratorio-container">
            <VolverBtn
              type="button"
              onClick={() => history.push("/autocheckin")}
              aria-label="Volver al inicio"
            >
              <FaChevronLeft />
              <span className="c-white rb16m">Volver</span>
            </VolverBtn>
            <TituloSaludo />
            <div className="ptur-laboratorio-buscador">
              {/* <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} /> */}
              {laboGrupoState.laboGrupo.data !== null && (
                <BuscadorLaboratorio
                  onChangeMultitabMobile={onChangeMultitabMobile}
                />
              )}
              <LaboratorioTxt />
            </div>
          </div>
        </motion.div>
      )}
      {/* <FooterBar /> */}
    </React.Fragment>
  );
};

export default Laboratorio;

const VolverBtn = styled.button`
  display: none;
  @media (min-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    padding: 0 12px;
    margin-bottom: 12px;
    border-radius: 8px;
    border: 1px solid var(--color-latex30);
    background: var(--color-latex10);
    color: var(--color-white);
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
    &:hover {
      background: var(--color-latex30);
    }
    svg {
      font-size: 16px;
      color: var(--color-white);
    }
  }
`;
